/**
 * CoureHub.ServiceOwner.Mgt
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ServiceMappingRequestDto } from '../model/serviceMappingRequestDto';
import { ServiceOwnerMappingGenericResponseDto } from '../model/serviceOwnerMappingGenericResponseDto';
import { ServiceType } from '../model/serviceType';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ServiceOwnerMappingService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param serviceType 
     * @param serviceProviderId 
     * @param serviceId 
     * @param serviceOwnerId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceOwnerMappingGetAllServiceOwnerMappingGet(serviceType?: ServiceType, serviceProviderId?: string, serviceId?: string, serviceOwnerId?: string, observe?: 'body', reportProgress?: boolean): Observable<ServiceOwnerMappingGenericResponseDto>;
    public apiServiceOwnerMappingGetAllServiceOwnerMappingGet(serviceType?: ServiceType, serviceProviderId?: string, serviceId?: string, serviceOwnerId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServiceOwnerMappingGenericResponseDto>>;
    public apiServiceOwnerMappingGetAllServiceOwnerMappingGet(serviceType?: ServiceType, serviceProviderId?: string, serviceId?: string, serviceOwnerId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServiceOwnerMappingGenericResponseDto>>;
    public apiServiceOwnerMappingGetAllServiceOwnerMappingGet(serviceType?: ServiceType, serviceProviderId?: string, serviceId?: string, serviceOwnerId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceType !== undefined && serviceType !== null) {
            queryParameters = queryParameters.set('ServiceType', <any>serviceType);
        }
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }
        if (serviceId !== undefined && serviceId !== null) {
            queryParameters = queryParameters.set('ServiceId', <any>serviceId);
        }
        if (serviceOwnerId !== undefined && serviceOwnerId !== null) {
            queryParameters = queryParameters.set('ServiceOwnerId', <any>serviceOwnerId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ServiceOwnerMappingGenericResponseDto>('get',`${this.basePath}/api/ServiceOwnerMapping/GetAllServiceOwnerMapping`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceOwnerId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceOwnerMappingGetServiceOwnerMappingServiceOwnerIdGet(serviceOwnerId: string, observe?: 'body', reportProgress?: boolean): Observable<ServiceOwnerMappingGenericResponseDto>;
    public apiServiceOwnerMappingGetServiceOwnerMappingServiceOwnerIdGet(serviceOwnerId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServiceOwnerMappingGenericResponseDto>>;
    public apiServiceOwnerMappingGetServiceOwnerMappingServiceOwnerIdGet(serviceOwnerId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServiceOwnerMappingGenericResponseDto>>;
    public apiServiceOwnerMappingGetServiceOwnerMappingServiceOwnerIdGet(serviceOwnerId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (serviceOwnerId === null || serviceOwnerId === undefined) {
            throw new Error('Required parameter serviceOwnerId was null or undefined when calling apiServiceOwnerMappingGetServiceOwnerMappingServiceOwnerIdGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ServiceOwnerMappingGenericResponseDto>('get',`${this.basePath}/api/ServiceOwnerMapping/GetServiceOwnerMapping/${encodeURIComponent(String(serviceOwnerId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceOwnerMappingMapServiceOwnerToSenderIDRequestPost(body?: ServiceMappingRequestDto, observe?: 'body', reportProgress?: boolean): Observable<ServiceOwnerMappingGenericResponseDto>;
    public apiServiceOwnerMappingMapServiceOwnerToSenderIDRequestPost(body?: ServiceMappingRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServiceOwnerMappingGenericResponseDto>>;
    public apiServiceOwnerMappingMapServiceOwnerToSenderIDRequestPost(body?: ServiceMappingRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServiceOwnerMappingGenericResponseDto>>;
    public apiServiceOwnerMappingMapServiceOwnerToSenderIDRequestPost(body?: ServiceMappingRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ServiceOwnerMappingGenericResponseDto>('post',`${this.basePath}/api/ServiceOwnerMapping/MapServiceOwnerToSenderIDRequest`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
